export default __webpack_public_path__ + "static/media/uploadplus.8f2e427c.svg";